// extracted by mini-css-extract-plugin
export var closeButton = "_7f-0";